<template>
    <div class="mrt20">
        <el-row>
            <el-col :span="4">
                <div>
                    <el-table
                            height="940"
                            :data="dgcData"
                            style="width: 100%"

                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                            >
                        <el-table-column
                                prop="vc_name"
                                label="代工厂">
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="20">
                <template>
                    <el-tabs type="border-card" @tab-click="dataListClick" >
                        <el-tab-pane   label="生产计划" >
                            <div v-if="tabIndex == '0'">
                                <div class="mrl20">
                                    <el-button type="primary" class="mrt10" :class="baseerp+'btn'" @click="addData">新增</el-button>
                                    <el-table
                                            class="mrt20"
                                            :data="productionData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="pid"
                                                label="计划编号"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pmname"
                                                :label="$t('form_company')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="代工厂"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="加工产品">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_createtime"
                                                label="类型"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_lruname"
                                                label="制表人"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_processCompany"
                                                label="录入时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_entrustCompany"
                                                label="已交付量"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="100">
                                            <template slot-scope="scope">
                                                <el-button @click="watchProClick(scope.row)" type="text" size="small">查看</el-button>
                                                <el-button @click="noticeProClick(scope.row)" type="text" size="small">推送</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="pageCurrentChange"
                                                :current-page.sync="currentPage"
                                                :total="tableTotal"
                                                :page-size="pageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="产出收货">
                            <div v-if="tabIndex == '1'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <span class="mrt10">选择交付日期:</span>
                                        <el-date-picker
                                                v-model="receivingbegin_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <span class="mrt10">至</span>
                                        <el-date-picker
                                                v-model="receivingend_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <el-input class="mrl20" style="width: 15%" v-model="receivingvcNo" placeholder="请输入生产批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="receivingSearch"></el-button>
                                    </div>
                                    <el-table
                                            class="mrt20"
                                            :data="receivingData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="i_outid"
                                                :label="$t('form_serial_number')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="生产批次号"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                :label="$t('form_delivery_quantity')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                label="状态">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="交付时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="交付人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="100">
                                            <template slot-scope="scope">
                                                <el-button @click="receivingWatchClick(scope.row)" type="text" size="small" >查看</el-button>
                                                <el-button @click="receivingClick(scope.row)" type="text" size="small">交付</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="receivingPageCurrentChange"
                                                :current-page.sync="receivingCurrentPage"
                                                :total="receivingTableTotal"
                                                :page-size="receivingPageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </el-row>
        <!--生产计划dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <plan-form :planForm="planForm" @close="cancelDialog" ></plan-form>
            </el-dialog>
        </div>
        <!--产出收货dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="receivingtitle"
                    :visible.sync="receivingdialogVisible"
                    :close-on-click-modal="false"
                    @close="receivingcancelDialog"
                    v-if="receivingdialogVisible">
                <receive-form :receiveForm="receiveForm" @close="receivingcancelDialog" ></receive-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import PlanForm from "../entrust/components/PlanForm";
    import ReceiveForm from "./components/ReceiveForm";
    export default {
        name: "entrust",  //委托加工
        components: {ReceiveForm, PlanForm},
        data() {
            return {
                baseerp:"",
                dgcData:[],
                tabIndex:0,

                //产出收货
                receivingbegin_time:"",
                receivingend_time:"",
                receivingvcNo:"",
                receivingData:[
                    {i_outid:1}
                ],
                receivingPageSize:10,
                receivingCurrentPage:1,
                receivingTableTotal:0,
                receivingdialogVisible:false,
                receiveForm:{},
                receivingtitle:"",
                //生产计划
                productionData:[
                    {pid:1}
                ],
                pageSize:10,
                currentPage:1,
                tableTotal:0,
                planForm:{},
                dialogVisible:false,
                title:"",
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            //关闭产出收货dialog
            receivingcancelDialog(){
                this.receivingdialogVisible=false;
            },

            //关闭生产计划dialog
            cancelDialog(){
                this.dialogVisible=false;
            },

            //点击产出收货分页
            receivingPageCurrentChange(val){
                //console.log(val,"pageval");
                this.receivingCurrentPage=val;
                ///调用生产计划列表接口

            },

            //点击产出收货交付
            receivingClick(row){
                //console.log(row,"点击产出收货交付");
                this.receivingtitle="产出收货交付";
                this.receivingdialogVisible=true;

            },

            //点击产出收货查看
            receivingWatchClick(row){
                //console.log(row,"点击产出收货查看");
                this.receivingtitle="查看产出收货";
                this.receivingdialogVisible=true;
            },

            //产出收货查询
            receivingSearch(){
                ///调用产出收货列表接口

            },

            //点击生产计划分页
            pageCurrentChange(val){
                //console.log(val,"pageval");
                this.currentPage=val;
                ///调用生产计划列表接口

            },

            //点击生产计划推送通知
            noticeProClick(row){
                //console.log(row,"生产计划推送通知");
                this.title="生产计划推送通知";
                this.dialogVisible=true;
            },

            //点击生产计划查看
            watchProClick(row){
                //console.log(row,"点击生产计划查看");
                this.title="查看生产计划";
                this.dialogVisible=true;
            },

            //点击生产计划新增
            addData(){
                this.title="新增生产计划";
                this.dialogVisible=true;
            },

            //选项框
            dataListClick(tab) {
                //console.log(tab,"tabtabtabtab");
                this.tabIndex = tab.index;
                if (this.id!==""&&this.tabIndex==0){
                    ///调用生产计划列表接口

                }else if (this.id!==""&&this.tabIndex==1){
                    ///调用产出收货列表接口

                }
            },
        },

    }
</script>

<style lang="scss" scoped>
    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }
    .mrt70{
        margin-top: 70px;
    }
    .mrt80{
        margin-top: 80px;
    }
    .mrl20{
        margin-left: 10px;
    }
    /deep/{
        .content{
            display: none;
        }
        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }
</style>